<template>
  <div>
    <base-nav
      v-model="showMenu"
      type="light"
      :transparent="true"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main"
      expand="lg"
    >
      <div slot="brand" class="navbar-wrapper">
        <router-link class="navbar-brand" to="/" style="text-shadow: 1px 1px #000">
          <span>Командор</span><sup>®</sup>
        </router-link>
      </div>

     <template>
       <div class="navbar-collapse-header">
         <div class="row">
           <div class="col-6 collapse-brand">
             <router-link to="/">
               <span class="nav-link-inner--text">Командор</span>
             </router-link>
           </div>
           <div class="col-6 collapse-close">
             <button type="button" class="navbar-toggler" @click="showMenu = false">
               <span></span>
               <span></span>
             </button>
           </div>
         </div>
       </div>

       <ul class="navbar-nav align-items-lg-center ml-lg-auto" style="text-shadow: 1px 1px #000">
         <router-link to="/features" class="nav-link">Функции</router-link>
         <router-link to="/safety" class="nav-link">Безопасность</router-link>
         <router-link to="/howto" class="nav-link">Как подключиться</router-link>
         <router-link to="/integration" class="nav-link">Интеграция</router-link>
         <router-link to="/info" class="nav-link">Информация</router-link>
         <router-link to="/pricing" class="btn btn-danger btn-icon" style="text-shadow: none">
           <span class="btn-inner--icon"><i class="fas fa-shopping-cart mr-2"></i></span>
           <span class="nav-link-inner--text">Купить подписку</span>
         </router-link>
       </ul>
     </template>
    </base-nav>

    <div class="main-content">
      <!--
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>\
      -->
      <router-view></router-view>
    </div>

    <!-- Footer -->
    <footer class="py-6 bg-dark text-light" id="footer-main">
      <div class="container">
        <div class="row align-items-center justify-content-xl-between">
          <div class="col-xl-6">
            <div class="copyright text-center text-xl-left">
              <span class="komandor">Командор<sup>®</sup></span>
              <p>Самый простой способ подписывать документы!</p>
            </div>
          </div>
          <div class="col-6">
            <ul class="nav text-light">
              <router-link to="/features" class="nav-link text-light ml--2 mr--2 font-weight-300">Функции</router-link>
              <router-link to="/safety" class="nav-link text-light ml--2 mr--2 font-weight-300">Безопасность</router-link>
              <router-link to="/howto" class="nav-link text-light ml--2 mr--2 font-weight-300">Как подключиться</router-link>
              <router-link to="/integration" class="nav-link text-light ml--2 mr--2 font-weight-300">Интеграция</router-link>
              <router-link to="/info" class="nav-link text-light ml--2 mr--2 font-weight-300">Информация</router-link>
            </ul>
          </div>
        </div>
        <div class="row">

        </div>
        <div class="row mt-5">
          <div class="col-6">
            <blockquote class="blockquote">
              <p>Каждый имеет право на неприкосновенность частной жизни, личную и семейную тайну, защиту своей чести и доброго имени.</p>
              <footer class="blockquote-footer">Конституция Российской Федерации Статья 23 часть 1</footer>
            </blockquote>
          </div>
          <div class="col-6">
            <blockquote class="blockquote">
              <p>Каждый имеет право на тайну переписки, телефонных переговоров, почтовых, телеграфных и иных сообщений. Ограничение этого права допускается только на основании судебного решения.</p>
              <footer class="blockquote-footer">Конституция Российской Федерации Статья 23 часть 2</footer>
            </blockquote>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <div class="row align-items-center">
          <div class="col d-flex justify-content-center">
            <img src="/img/icons/1.png" height="12"/>&nbsp;
            <img src="/img/icons/2.png" height="12"/>&nbsp;
            <img src="/img/icons/3.png" height="12"/>&nbsp;
            <img src="/img/icons/4.png" height="12"/>&nbsp;
            <img src="/img/icons/5.png" height="12"/>&nbsp;
            <img src="/img/icons/6.png" height="12"/>&nbsp;
            <img src="/img/icons/7.png" height="12"/>&nbsp;
            <img src="/img/icons/8.png" height="12"/>&nbsp;
            <img src="/img/icons/9.png" height="12"/>&nbsp;
          </div>
        </div>
      </div>
    </footer>
    <!-- //Footer -->

  </div>
</template>
<script>
  import { BaseNav } from '@/components';
  import { ZoomCenterTransition } from 'vue2-transitions';

  export default {
    components: {
      BaseNav,
      ZoomCenterTransition
    },
    props: {
      backgroundColor: {
        type: String,
        default: 'black'
      }
    },
    data() {
      return {
        showMenu: false,
        menuTransitionDuration: 200,
        pageTransitionDuration: 200,
        year: new Date().getFullYear(),
        pageClass: 'login-page'
      };
    },
    computed: {
      title() {
        return `${this.$route.name} Page`;
      }
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle('nav-open');
        this.showMenu = !this.showMenu;
      },
      closeMenu() {
        document.body.classList.remove('nav-open');
        this.showMenu = false;
      },
      setBackgroundColor() {
        document.body.classList.add('bg-default');
      },
      removeBackgroundColor() {
        document.body.classList.remove('bg-default');
      },
      updateBackground() {
        if (!this.$route.meta.noBodyBackground) {
          this.setBackgroundColor();
        } else {
          this.removeBackgroundColor()
        }
      }
    },
    beforeDestroy() {
      this.removeBackgroundColor();
    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        this.closeMenu();
        setTimeout(() => {
          next();
        }, this.menuTransitionDuration);
      } else {
        next();
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler: function () {
          this.updateBackground()
        }
      }
    }
  };
</script>
<style lang="scss">
  $scaleSize: 0.8;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }

  .main-content .zoomIn {
    animation-name: zoomIn8;
  }

  @keyframes zoomOut8 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }

  .main-content .zoomOut {
    animation-name: zoomOut8;
  }
</style>
